import z from 'zod';

export type MenuPlannerCreatedDto = {
	id: string;
	title: string | null;
};

export const MenuPlannerCreatedDtoSchema: z.ZodType<MenuPlannerCreatedDto> = z.object({
	id: z.string(),
	title: z.string().nullable(),
});
